<ng-container *ngIf="data$ | async as data; else spinner">
	<div class="button-bar" *ngIf="!!buttons && !actionInProgress">
		<div class="buttons">
			<div class="buttons">
				<ng-container *ngFor="let button of buttons">
					<button
						*ngIf="$any(button).visible()"
						(click)="button.click()"
						[class]="button.class"
						[translate]="button.translate"
						[disabled]="$any(button).disabled()"
						type="button"
					></button>
				</ng-container>
			</div>
		</div>
	</div>

	<ng-template #list>
		<ng-container *ngIf="isSelectDeselectButtonsEnabled()">
			<ng-container *ngTemplateOutlet="selectDeselectAllButtonTemplate"></ng-container>
		</ng-container>
		<div class="information no-border" *ngIf="informationTemplate">
			<ng-container *ngTemplateOutlet="informationTemplate; context: { $implicit: data }"></ng-container>
		</div>
		<ul [class]="listStyles">
			<li class="list-item" *ngIf="listHeaderTemplate">
				<ng-container *ngTemplateOutlet="listHeaderTemplate; context: { $implicit: data }"></ng-container>
			</li>

			<ng-container *ngIf="mode === Mode.ADD">
				<li class="relative list-item add-item">
					<div class="fullsize">
						<ng-container *ngIf="!autoCompleteTemplate">
							<stages-add
								[focusOnInit]="true"
								[placeholder]="getSearchPlaceHolder() | translate"
								[maxLength]="addMaxLength"
								[pattern]="addPattern"
								[patternMessageKey]="addPatternMessageKey"
								(submitted)="add($event)"
								(focusLost)="cancelAdd()"
								(cancelled)="cancelAdd()"
								class="relative"
							>
							</stages-add>
						</ng-container>
						<ng-container *ngIf="autoCompleteTemplate">
							<stages-auto-complete-search
								[focusOnInit]="true"
								[placeholder]="getSearchPlaceHolder() | translate"
								[query]="dataSource.newSearchQuery()"
								(submitted)="add($event)"
								(cancelled)="cancelAdd()"
								(focusLost)="cancelAdd()"
								[searchResultTemplate]="autoCompleteTemplate"
								[browseButtonActive]="browseItemButtonActive"
								(openBrowserButtonPressed)="openButtonPressed()"
								(closeButtonPressed)="closeButtonPressed()"
								class="relative"
							>
							</stages-auto-complete-search>
							<p *ngIf="autoCompleteBrowseTemplate" [class]="autoCompleteBrowseTemplatePragraphStyles">
								<ng-container *ngTemplateOutlet="autoCompleteBrowseTemplate"></ng-container>
							</p>
						</ng-container>
					</div>
				</li>
			</ng-container>
			<ng-container *ngIf="searchEngineAvailable || !hasActiveFilters()">
				<ng-container *ngFor="let item of data.items; trackBy: trackBy">
					<li class="list-item" [ngClass]="getClasses(item)" [class.disabled]="inactiveFn(item)">
						<div *ngIf="selectable" class="select">
							<input
								type="checkbox"
								class="checkbox"
								[id]="'select' + idFn(item)"
								[name]="'select' + idFn(item)"
								[checked]="
									(!idFnNew && selection.isSelected(idFn(item))) ||
									(item
										| selectionStoreIsSelected
											: storeIdentifier
											: isSelectAllActivated
											: triggerChangeCounter
											: idFnNew
											: isPreselectedFn)
								"
								(change)="toggleSelection(item)"
								[disabled]="disabledFn(item, data, mode)"
								[indeterminate]="
									item | selectionStoreIsPartiallySelected : storeIdentifier : triggerChangeCounter : false : idFnNew
								"
							/>
							<label [for]="'select' + idFn(item)"></label>
						</div>
						<ng-container *ngTemplateOutlet="listItemTemplate!; context: { $implicit: item }"></ng-container>
					</li>
				</ng-container>

				<li class="list-item" *ngIf="data.page < data.totalPageCount && showMore">
					<a class="label clickable" (click)="dataSource.loadMore()" role="button" tabindex="0">
						<div class="avatar-cell-48"></div>
						<div class="text center">
							<span class="show-more" translate="more"></span>
						</div>
					</a>
				</li>

				<ng-container *ngIf="!!translateNone && data.totalItemCount === 0">
					<ng-container *ngTemplateOutlet="listInfoMessage; context: { $implicit: translateNone }"></ng-container>
				</ng-container>
			</ng-container>

			<ng-container *ngIf="!searchEngineAvailable && hasActiveFilters()">
				<ng-container *ngTemplateOutlet="listInfoMessage; context: { $implicit: 'search.notavailable' }"></ng-container>
			</ng-container>
		</ul>
		<li class="list-item" *ngIf="isSelectAllEnabled()">
			<ng-container *ngTemplateOutlet="selectAllTemplate"></ng-container>
		</li>
	</ng-template>

	<ng-template #table>
		<div class="information no-border" *ngIf="informationTemplate">
			<ng-container *ngTemplateOutlet="informationTemplate; context: { $implicit: data }"></ng-container>
		</div>
		<table class="table center" *ngIf="searchEngineAvailable || !hasActiveFilters()">
			<thead *ngIf="headerTemplate && !(!!translateNone && data.totalItemCount === 0)">
				<tr>
					<th *ngIf="selectable" class="select"></th>
					<ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
				</tr>
			</thead>

			<tbody [ngClass]="mode === Mode.REARRANGE ? 'sortable-container' : ''">
				<tr *ngIf="autoCompleteTemplate && mode === Mode.ADD" class="add-item">
					<td class="relative" [attr.colspan]="tableColumns">
						<stages-auto-complete-search
							[focusOnInit]="true"
							[placeholder]="getSearchPlaceHolder() | translate"
							[query]="dataSource.newSearchQuery()"
							(submitted)="add($event)"
							(cancelled)="cancelAdd()"
							(focusLost)="cancelAdd()"
							[searchResultTemplate]="autoCompleteTemplate"
							[browseButtonActive]="browseItemButtonActive"
							(openBrowserButtonPressed)="openButtonPressed()"
							(closeButtonPressed)="closeButtonPressed()"
							class="relative"
						>
						</stages-auto-complete-search>
						<p *ngIf="autoCompleteBrowseTemplate">
							<ng-container *ngTemplateOutlet="autoCompleteBrowseTemplate"></ng-container>
						</p>
					</td>
				</tr>

				<tr *ngIf="!autoCompleteTemplate && mode === Mode.ADD" class="add-item">
					<td class="relative" [attr.colspan]="tableColumns">
						<stages-add
							[focusOnInit]="true"
							[placeholder]="getSearchPlaceHolder() | translate"
							[maxLength]="addMaxLength"
							[pattern]="addPattern"
							[patternMessageKey]="addPatternMessageKey"
							(submitted)="add($event)"
							(focusLost)="cancelAdd()"
							(cancelled)="cancelAdd()"
							class="relative"
						>
						</stages-add>
					</td>
				</tr>

				<tr
					*ngFor="let item of data.items; trackBy: trackBy"
					[ngClass]="getClasses(item)"
					[class.disabled]="inactiveFn(item)"
				>
					<td *ngIf="selectable" class="select">
						<input
							type="checkbox"
							class="checkbox"
							[id]="'select' + idFn(item)"
							[name]="'select' + idFn(item)"
							[checked]="
								(!idFnNew && selection.isSelected(idFn(item))) ||
								(item
									| selectionStoreIsSelected
										: storeIdentifier
										: isSelectAllActivated
										: triggerChangeCounter
										: idFnNew
										: isPreselectedFn)
							"
							(change)="toggleSelection(item)"
							[disabled]="disabledFn(item, data, mode)"
							[indeterminate]="
								item | selectionStoreIsPartiallySelected : storeIdentifier : triggerChangeCounter : false : idFnNew
							"
						/>
						<label [for]="'select' + idFn(item)"></label>
					</td>
					<ng-container *ngTemplateOutlet="tableItemTemplate!; context: { $implicit: item }"></ng-container>
				</tr>
			</tbody>
		</table>
		<footer *ngIf="data.page < data.totalPageCount && showMore">
			<ul class="list">
				<li class="list-item no-padding no-hover">
					<a class="label clickable" (click)="dataSource.loadMore()" role="button" tabindex="0">
						<div class="avatar-cell-48"></div>
						<div class="text center">
							<span class="show-more" translate="more"></span>
						</div>
					</a>
				</li>
			</ul>
		</footer>
		<ul class="list" *ngIf="isSelectAllEnabled()">
			<li class="list-item">
				<ng-container *ngTemplateOutlet="selectAllTemplate"></ng-container>
			</li>
		</ul>
		<ng-container
			*ngIf="!!translateNone && data.totalItemCount === 0 && (searchEngineAvailable || !hasActiveFilters())"
		>
			<ul class="list">
				<ng-container *ngTemplateOutlet="listInfoMessage; context: { $implicit: translateNone }"></ng-container>
			</ul>
		</ng-container>
		<ng-container *ngIf="!searchEngineAvailable && hasActiveFilters()">
			<ul class="list">
				<ng-container *ngTemplateOutlet="listInfoMessage; context: { $implicit: 'search.notavailable' }"></ng-container>
			</ul>
		</ng-container>
	</ng-template>

	<form class="form" *ngIf="(data.items.length > 0 || activeFilters.size > 0) && dataSource.filterEnabled()">
		<ng-container *ngIf="filterTemplate">
			<ng-container *ngTemplateOutlet="filterTemplate"></ng-container>
		</ng-container>
		<div class="input-container" *ngIf="!filterTemplate">
			<stages-rdv-text-filter
				[identifier]="'filterTerm'"
				[activeFilters]="activeFilters"
				[placeholder]="getFilterPlaceHolder()"
				(keyUpFired)="onFilterChange($event)"
			></stages-rdv-text-filter>
		</div>
	</form>

	<ng-container *ngIf="!useBreakpointObserver">
		<stages-media-query *ngIf="listItemTemplate && tableItemTemplate" #media query="screen and (max-width:1440px)">
			<ng-container *ngIf="media.matches">
				<ng-container *ngTemplateOutlet="list"></ng-container>
			</ng-container>
			<ng-container *ngIf="!media.matches">
				<ng-container *ngTemplateOutlet="table"></ng-container>
			</ng-container>
		</stages-media-query>
	</ng-container>

	<ng-container *ngIf="useBreakpointObserver">
		<stages-media-query *ngIf="listItemTemplate && tableItemTemplate">
			<ng-container *ngIf="showListTemplate()">
				<ng-container *ngTemplateOutlet="list"></ng-container>
			</ng-container>
			<ng-container *ngIf="!showListTemplate()">
				<ng-container *ngTemplateOutlet="table"></ng-container>
			</ng-container>
		</stages-media-query>
	</ng-container>

	<ng-container *ngIf="listItemTemplate && !tableItemTemplate">
		<ng-container *ngTemplateOutlet="list"></ng-container>
	</ng-container>
	<ng-container *ngIf="tableItemTemplate && !listItemTemplate">
		<ng-container *ngTemplateOutlet="table"></ng-container>
	</ng-container>

	<div class="list" *ngIf="data.totalPageCount > 1 && !showMore">
		<footer class="footer-pager">
			<stages-pager
				[pageSize]="data.pageSize ? data.pageSize : pageSize"
				[total]="data.totalItemCount"
				[page]="data.page"
				(goTo)="dataSource.goTo($event)"
			></stages-pager>
		</footer>
	</div>
</ng-container>

<ng-template #spinner>
	<stages-spin size="sm"></stages-spin>
</ng-template>

<ng-template #selectAllTemplate>
	<h5 translate="select.all" class="no-margin"></h5>
	<input
		id="selectAll"
		type="checkbox"
		hidden="hidden"
		[checked]="isSelectAllActivated"
		(click)="selectDeselectAll()"
	/>
	<label for="selectAll" class="switch"></label>
</ng-template>

<ng-template #listInfoMessage let-context>
	<li class="list-item none">
		<div class="label">
			<p [translate]="context"></p>
		</div>
	</li>
</ng-template>

<ng-template #selectDeselectAllButtonTemplate>
	<stages-buttons-bottom [removeBoundaries]="true" [alignRight]="false" [isOnTop]="true" [addPadding]="true">
		<button class="button sm" type="button" translate="select.all" (click)="selectAll()"></button>
		<button class="button sm" type="button" translate="deselect.all" (click)="deselectAll()"></button>
	</stages-buttons-bottom>
</ng-template>
